import { getSidebar } from "@/data/news";
import { PostOrPage } from "@tryghost/content-api";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { Footer } from "../../../components/Footer";
import { StaticGhostPage } from "@/components/StaticGhostPage";
import getPage from "@/news/getPage";
import { Nav } from "../../../components/common/FrontendNav";
import { setGhostCacheHeader } from "@/helper/cacheHeaders";

export async function getServerSideProps(context: any) {
  const { res } = context;
  setGhostCacheHeader(res);
  const page = await getPage(
    context.locale === "de"
      ? "69df638d87270500019ca869"
      : "6a0dac9d10b7cf0001d52bc3",
  );
  const sidebar = await getSidebar(context.locale);

  return {
    props: {
      page,
      sidebar,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface PokalGrandOpeningPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
}

export default function PokalGrandOpeningPage({
  page,sidebar,
}: PokalGrandOpeningPageProps) {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{`${t("Table_Tennis")} Bundesliga - TTBL - ${t(
          "Title_Pokal_Grand_Opening",
        )}`}</title>
      </Head>
      <div>
        <Nav />
        <StaticGhostPage page={page} sidebar={sidebar} />
        <Footer />
      </div>
    </>
  );
}
